
export default {
  props: {
    publication: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardProps () {
      return {
        color: this.color,
        image: this.image,
        title: this.title,
      }
    },
    color () {
      return this.$attrs.color || (this.active ? 'primary' : 'grey-700')
    },
    image () {
      return this.publication?.hero || 'https://nederlandzingt-eo.cdn.eo.nl/{format}/1iuv2gkferxr-fallback-afbeelding.png'
    },
    title () {
      return this.publication?.title
    },
  },
}
